import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ReconcileRxChangeRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchReconcileRxChange } from '../api/reconcileRxChange.js';
import { rxKeys } from './keys.js';

export interface ReconcileRxChangeVariables {
  rxChangeId: number;
  userId: string;
  data: ReconcileRxChangeRequestT;
  pendingParams?: {
    detailed?: Parameters<typeof rxKeys.pendingRxChangesDetailed>[0];
  };
}

export function useReconcileRxChangeMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'rxchanges', 'reconcile'],
    mutationFn: async ({
      rxChangeId,
      userId,
      data,
    }: ReconcileRxChangeVariables): Promise<unknown> => {
      return await fetchReconcileRxChange(rxChangeId, userId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: rxKeys.pendingRxChangesDetailed(variables.pendingParams?.detailed),
      });
    },
  });
}
